export const SUPPORT_EMAIL = "support@upside.tools";

export function supportMailto(subject?: string): string {
  return subject === undefined ? `mailto:${SUPPORT_EMAIL}` : `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;
}
